export const ROLE = 'ROLE';
export function role(role){
    return {
        type: ROLE,
        payload:{
            role: role
        }
    }
}
